import { Pipe, PipeTransform } from '@angular/core';
import { HOLD, holdStatusTypes, OTHER } from '../../../ngrx/status-types';

@Pipe({
  name: 'jobHoldReason'
})
export class JobHoldReasonPipe implements PipeTransform {
  transform(jobs: any[], holdReason: string): any[] {
    return jobs.map(job => {
      let o = Object.assign({}, job);
      let latest = 0;
      job.activity_history.sort((a,b)=> Number(b.timestamp) - Number(a.timestamp));
      job.activity_history.forEach(act => {
        if(act.activity === 'hold' && latest < Number(act.timestamp) ) {
          latest = Number(act.timestamp);
          o.note = act.note;
          o.comment = act.comment;
        }
      })
      return o;
    }).filter(job => {
      if (holdReason === 'ALL') {
        return job.status === HOLD;
      } else if (holdReason === OTHER) {
        return (job.status === HOLD && (job.note == OTHER || holdStatusTypes.indexOf(job.note) == -1));
      } else {
        return job.status === HOLD && job.note === holdReason;
      }
    });
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/job-hold-reason.pipe.ts